import React from "react";
import { getCandidateConfig } from "../../../../config/candidates";
import {
  BsInstagram,
  BsTwitterX,
  BsFacebook,
  BsTiktok,
  BsLinkedin,
  BsYoutube,
} from "react-icons/bs";

export const Footer: React.FC = () => {
    const { socialMedia } = getCandidateConfig();

  return (
    <footer className="bg-[#e6e6e6] text-[#9a9a9a] font-bold p-8 w-full">
      <div className="container  mx-auto w-full max-w-screen-lg flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-center">
          &copy; {new Date().getFullYear()} {process.env.REACT_APP_CANDIDATE_NAME}. Todos los derechos
          reservados.
        </div>
        <div className="flex gap-4 flex-col md:flex-row ">
          <div className="text-center">Sigue a {process.env.REACT_APP_CANDIDATE_NAME?.split(" ")[0]} en sus redes sociales</div>
            <div className="flex gap-1 justify-center">
            {socialMedia?.facebook && (
              <a
                href={socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2 hover:text-tertiary"
              >
                <BsFacebook size={20} />
              </a>
            )}
            {socialMedia?.twitter && (
            <a
              href={socialMedia.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="mx-2 hover:text-tertiary"
            >
              <BsTwitterX size={20} />
            </a>
             )}
             {socialMedia?.youtube && (
            <a
              href={socialMedia.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="mx-2 hover:text-tertiary"
            >
              <BsYoutube size={20} />
            </a>
            )}
            {socialMedia?.linkedin && (
              <a
                href={socialMedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2 hover:text-tertiary"
              >
                <BsLinkedin size={20} />
              </a>
            )}
            {socialMedia?.instagram && (
              <a
                href={socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2 hover:text-tertiary"
              >
                <BsInstagram size={20} />
              </a>
            )}
            {socialMedia?.tiktok && (
              <a
                href={socialMedia.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-2 hover:text-tertiary"
              >
                <BsTiktok size={20} />
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};
